import api from "./api.js";

export default class MembershipApplyApi {
  static async getList(data) {
    return await api.get(`api/membership-apply`, data);
  }

  static async getDetail(id) {
    return await api.get(`api/membership-apply/${id}`);
  }
}
